import { convertPropToCssClassName } from '@elliemae/ds-classnames';

var _convertPropToCssClas = convertPropToCssClassName('accordion-item'),
    classNameElement = _convertPropToCssClas.classNameElement;
var accordionActions = classNameElement('accordion-actions');
var accordionTitleWrapper = classNameElement('title-wrapper');
var accordionH2Title = classNameElement('h2-title');
var accordionSecondaryTitle = classNameElement('secondary-title');
var accordionTitle = classNameElement('title');
var accordionButton = classNameElement('accordion-button');

export { accordionActions, accordionButton, accordionH2Title, accordionSecondaryTitle, accordionTitle, accordionTitleWrapper, classNameElement };
//# sourceMappingURL=blocks.js.map
